let state = {
  // 缓存的路由id数组
  infoList: [],
  // 当前点击的路由id值
  currentBarId: 0
}

export default state
